"use client"

import { NotificationProvider } from "@/context/notification-context-simple"
import { LanguageProvider } from "@/context/language-context"
import { NotificationCenter } from "@/components/notification-center"
import { useEffect } from "react"
import { requestTokenFromParent } from "@/lib/app-messaging"
import { useAuth } from "@/contexts/auth-context"
import { Loader2 } from "lucide-react"

export default function Home() {
  const {isAuthenticated} = useAuth()

  useEffect(() => {
    // Make sure we're in a browser environment
    if (typeof window !== "undefined") {
      // Use a small timeout to ensure the app is fully rendered
      const timer = setTimeout(() => {
        requestTokenFromParent()
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [])

  if(!isAuthenticated){
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="w-12 h-12 animate-spin text-slate-600" />
      </div>
    )
  }
  
  return (
    <div className="h-screen overflow-hidden">
      <LanguageProvider>
        <NotificationProvider>
          <NotificationCenter />
        </NotificationProvider>
      </LanguageProvider>
    </div>
  )
} 